import moment from 'moment';
import { TRACK_INTERACTION, triggerEvent } from '@fec/assets/js/utils/event';

const REFRESH_INTERVAL = 30000;
// in px; for non-touch features like clickable map, tooltips
const DESKTOP_BREAKPOINT = 500;

const CANTON_NAMES = [];
const CANTON_SHORT_NAMES = [];
let YES = '';
let NO = '';

export function init() {
  let $maps = $(css.polisWrapper);
  initConstants();
  if ($maps.length) {
    $maps.each(function () {
      initMap($(this));
    });
  }
}

let css = {
  // map
  polisMap: '.polis-map',
  polisWrapper: '.js-polis-container',
  cantonSelect: '.js-polis-menu',
  hiddenClass: 'polis--hide',
  tooltip: '#polis-tooltip',
  tooltipTextYes: 'chmap-tooltip-text--yes',
  tooltipTextNo: 'chmap-tooltip-text--no',
  mapPolygons: '.chmap--no-touch g',
  // main bar
  mainBarContainer: '.polis-result-container--main',
  totalAbsoluteYesResult: '.js-polis-result-total--absoluteYes',
  totalAbsoluteNoResult: '.js-polis-result-total--absoluteNo',
  totalRelativeYesBar: '.js-polis-result-total--yesBar',
  totalRelativeNoBar: '.js-polis-result-total--noBar',
  totalRelativeYesResult: '.js-polis-result-total-relativeYes',
  totalRelativeNoResult: '.js-polis-result-total-relativeNo',
  cantonalMajorityYesBar: '.js-polis-result-cantonalmajority--yesBar',
  cantonalMajorityNoBar: '.js-polis-result-cantonalmajority--noBar',
  cantonalMajorityYesResult: '.js-polis-result-cantonalmajority-yesResult',
  cantonalMajorityNoResult: '.js-polis-result-cantonalmajority-noResult',
  cantonalMajorityDefaultResult: '.polis-result.polis-result--default',
  defaultColor: 'polis-result--default',
  participation: '.js-polis-participation',
  statusLine: '.js-polis-result-total--statusline',
  // canton detail view
  cantonContainer: '.polis-cantons-container',
  cantonTitle: '.polis-result-title--canton-name',
  districtsWrapper: '.polis-districts-wrapper',
  districtContainer: '.polis-district-container',
  cantonalMainResult: '.polis-result-container--canton',
};

function initConstants() {
  let $option = null;
  $(css.cantonSelect)
    .find('option')
    .each(function () {
      $option = $(this);
      CANTON_NAMES.push($option.text());
      CANTON_SHORT_NAMES.push($option.val());
    });

  YES = $(css.polisWrapper).data('yes');
  NO = $(css.polisWrapper).data('no');
}

function initMap($container) {
  let $map = $container.find(css.polisMap);
  // "Kantonale Vorlagen" only have a MainBar and do not have a map. Update after page load is not implemented for this votation type
  if ($map.length) {
    let id = String($map.attr('id'));
    let map = new PolisMap(
      id,
      $container,
      $map,
      $map.data('vote'),
      $map.data('api'),
      $map.data('has-cantonal-majority'),
    );
    map.fetchData();
    map.registerListener();

    // track init
    triggerEvent(TRACK_INTERACTION, {
      event_type: 'hidden_event',
      event_source: 'polis-' + id,
      event_name: 'loaded',
    });

    window.setInterval(map.fetchData.bind(map), REFRESH_INTERVAL);
  }
}

function PolisMap(
  cssId,
  $container,
  $map,
  voteId,
  apiUrl,
  hasCantonalMajority,
) {
  this.id = cssId;
  this.$container = $container;
  this.$map = $map;
  this.voteId = voteId;
  this.apiUrl = apiUrl;
  // cantonalMajority = Ständemehr
  this.hasCantonalMajority = hasCantonalMajority === 1;
  this.mainBar = null;
  this.$mainBar = null;
  this.$tooltip = null;
  this.caseDate = '';
  this.isInitialRender = true;
  this.result = null;
  this.selectedCanton = undefined;
  this.defaultCantonSelectText = this.$container
    .find(css.cantonSelect)
    .find('option')
    .first()
    .text();

  this.cantonIdMap = {};
  this.cantons = {};
  let $cantonContainer = this.$container.find(css.cantonContainer);

  CANTON_SHORT_NAMES.forEach((abbr) => {
    this.cantons[abbr + ''] = new Canton(this.id, abbr, $cantonContainer);
  });

  this.getCantonById = function (cantonId) {
    if (this.cantons.hasOwnProperty(cantonId)) {
      return this.cantons[cantonId];
    }
  };

  this.registerListener = function () {
    let that = this;

    that.$container.find(css.cantonSelect).on('change', function () {
      that.onCantonSelect($(this));
    });

    if (screen.width >= DESKTOP_BREAKPOINT) {
      that.registerWideScreenListener();
    } else {
      that.registerSmallScreenListener();
    }
  };

  // ignore clicks on map
  this.registerSmallScreenListener = function () {
    let $polygons = this.$container.find(css.mapPolygons);

    $polygons.on('click', function (event) {
      event.preventDefault();
    });
  };

  // have tooltips and clickable map
  this.registerWideScreenListener = function () {
    let that = this;
    let $polygons = that.$container.find(css.mapPolygons);

    $polygons
      .on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        that.onMapClick($(this));
      })
      .on('mousemove', function (event) {
        that.onMapMouseMove(event.pageX, event.pageY);
      })
      .on('mouseenter', function () {
        that.onMapMouseEnter($(this));
      })
      .on('mouseleave', function () {
        that.onMapMouseLeave($(this));
      });

    // for polygons with shadow (clicked)
    $('#selector-' + voteId)
      .on('mouseenter', function () {
        that.onMapMouseEnter($(this));
      })
      .on('mousemove', function (event) {
        that.onMapMouseMove(event.pageX, event.pageY);
      })
      .on('mouseleave', function () {
        that.onMapMouseLeave($(this));
      });
  };

  this.onMapMouseEnter = function ($target) {
    let cantonId = '';
    if ($target.is('.polis-initial') && this.$tooltip) {
      return;
    } else if ($target.is('use')) {
      cantonId = this.extractCantonId($target.attr('xlink:href').substr(1));
    } else {
      cantonId = this.extractCantonId($target.attr('id'));
    }
    let canton = this.getCantonById(cantonId);
    let html = this.getToolTipContent(canton.name, canton.yes, canton.no);
    if ($(css.tooltip).length === 0) {
      $('body').append(
        '<div id="polis-tooltip" class="chmap-tooltip polis--hide">' +
          html +
          '</div>',
      );
    } // there's only one tooltip per page
    if (this.$tooltip === null) {
      this.$tooltip = $(css.tooltip);
    }
    this.$tooltip.html(html);
    if (canton.yes && canton.no) {
      this.$tooltip.removeClass(css.hiddenClass);
    }
  };

  this.extractCantonId = function (cantonId) {
    cantonId = cantonId.split('-')[0];
    return cantonId;
  };

  this.onMapMouseLeave = function () {
    this.$tooltip.addClass(css.hiddenClass);
  };

  this.onMapMouseMove = function (x, y) {
    let pageY = y - this.$tooltip.outerHeight() - 20; // 90;
    let pageX = x;

    let cssClass = 'left';
    if (pageX > $(window).width() / 2) {
      cssClass = 'right';
      pageX = pageX - this.$tooltip.outerWidth();
    }

    this.$tooltip
      .css({ top: pageY, left: pageX })
      .removeClass('chmap-tooltip--left chmap-tooltip--right')
      .addClass('chmap-tooltip--' + cssClass);
  };

  this.onMapClick = function ($clicked) {
    if ($clicked.is('.polis-initial')) {
      return;
    }

    let cantonId = this.extractCantonId($clicked.closest('g').attr('id'));
    // click on already selected canton => deselect
    if (this.selectedCanton === cantonId) {
      // reset dropdown
      this.$container.find(css.cantonSelect).val('');
      this.deselectCantons();
      return;
    }

    const canton = this.getCantonById(cantonId);

    this.selectedCanton = cantonId;
    this.$container.find(css.cantonSelect).val(cantonId);
    canton.renderResults();
    this.markSelectedCanton(cantonId);
  };

  // selection via dropdown menu
  this.onCantonSelect = function ($clicked) {
    let cantonId = $clicked.val();

    //track canton/de-select
    triggerEvent(TRACK_INTERACTION, {
      event_type: 'click',
      event_source: 'polis-' + this.voteId,
      event_name: 'menu-' + (cantonId || 'none'),
    });

    if (cantonId === '') {
      this.deselectCantons();
    } else {
      let canton = this.getCantonById(cantonId);
      this.selectedCanton = cantonId;
      canton.renderResults();
      this.markSelectedCanton(cantonId);
    }
  };

  this.markSelectedCanton = function (cantonId) {
    const elementId = cantonId + '-' + this.id;
    // repaint chosen canton (on top)
    $('#selector-' + this.id).attr('xlink:href', '#' + elementId);

    this.$container.find('.chmap__location').each((_, element) =>
      $(element)
        .toggleClass('chmap__location--unselected', element.id !== elementId)
        .toggleClass('chmap__location--selected', element.id === elementId),
    );
  };

  this.deselectCantons = function () {
    this.$container
      .find('.chmap__location--unselected, .chmap__location--selected')
      .removeClass('chmap__location--unselected chmap__location--selected');
    this.$container.find(css.districtsWrapper).hide();
    this.resetSelectedCanton();
  };

  this.getToolTipContent = function (name = '', yes = '', no = '') {
    let noClass = '';
    let yesClass = '';

    if (yes > no) {
      yesClass = css.tooltipTextYes;
    } else {
      noClass = css.tooltipTextNo;
    }
    return `
      <p class="chmap-tooltip__title">${name}</p>
      <p class="chmap-tooltip-text ${yesClass}">${yes}% ${YES.toUpperCase()}</p>&nbsp;
      <p class="chmap-tooltip-text ${noClass}">${no}% ${NO.toUpperCase()}</p>
    `;
  };

  this.fetchData = function () {
    let that = this;
    $.getJSON(that.apiUrl, function (data) {
      if (data.votes && data.votes[that.voteId]) {
        that.result = data.votes[that.voteId];
        that.caseDate = data.voteCase.date;

        if (that.isInitialRender) {
          that.loadResults();
          that.isInitialRender = false;
          that.$mainBar = that.$container.find(css.mainBarContainer);
          that.mainBar = new MainBar(that);
          that.mainBar.update();
          that.renderCantonSelect();
        } else {
          that.updateResults();
          that.mainBar.update();
        }
      }
    });
  };

  this.loadResults = function () {
    let cantonsWithData = [];
    this.cantonIdMap = {};

    if (this.result && this.result.results) {
      // build a map cantonId -> cantonShortName
      this.result.results.results.forEach(
        function (result) {
          if (result.location.type.id === 2) {
            this.cantonIdMap[result.location.id] = result.location.shortName;
          }
        }.bind(this),
      );

      this.result.results.results.forEach(
        function (result) {
          let canton;
          if (
            result.resultCondition.id === 2 ||
            result.resultCondition.id === 3
          ) {
            // 2: accepted, 3: declined
            // its a canton
            if (result.location.type.id === 2) {
              if (this.cantons.hasOwnProperty(result.location.shortName)) {
                canton = this.cantons[result.location.shortName];
                canton.absoluteVotes = result.absolute;
                canton.setYes(result.relative.yes);
                canton.no = result.relative.no;
                canton.name = result.location.locationName;
                canton.results = new ResultSet(result, this);
                cantonsWithData.push(result.location.shortName);
              }
            } else if (result.location.type.id === 3) {
              // it's a district
              let cantonShortName =
                this.cantonIdMap[result.location.parentLocationId];
              if (this.cantons.hasOwnProperty(cantonShortName)) {
                let resultSet = new ResultSet(result, this);
                canton = this.cantons[cantonShortName];
                canton.setResultForDistrict(
                  result.location.locationName,
                  resultSet,
                );
              }
            }
          }
        }.bind(this),
      );
    }

    // reset those cantons without data
    Object.keys(this.cantons).forEach(
      function (canton) {
        if (cantonsWithData.indexOf(canton) === -1) {
          this.cantons[canton].reset();

          // if selected canton has no data anymore, reset it
          if (this.selectedCanton === canton) {
            this.deselectCantons();
          }
        }
      }.bind(this),
    );

    // re-select selected canton after re-rendering
    if (this.selectedCanton) {
      this.markSelectedCanton(this.selectedCanton);
    }
  };

  this.resetSelectedCanton = function () {
    this.selectedCanton = null;
  };

  this.updateResults = function () {
    this.loadResults();
    this.renderCantonSelect();

    if (this.selectedCanton && this.cantons[this.selectedCanton]) {
      this.cantons[this.selectedCanton].renderResults();
    }
  };

  this.getCantonSelectOption = function (cantonId) {
    let index = CANTON_SHORT_NAMES.indexOf(cantonId);
    let selected = this.selectedCanton === cantonId ? 'selected' : '';
    return `<option value="${cantonId}" ${selected}>${CANTON_NAMES[index]}</option> `;
  };

  // no hiding of options via CSS because of Safari
  this.renderCantonSelect = function () {
    let $select = this.$container.find(css.cantonSelect);
    let options = '';
    let i = 0;
    for (let cantonId in this.cantons) {
      if (this.cantons[cantonId].hasResults()) {
        options += this.getCantonSelectOption(cantonId);
        i++;
      }
    }

    if (i === 0) {
      // inactive menu if there's no option to select
      $select.attr('disabled', true);
      options = `<option value="">${$select
        .find('option')
        .first()
        .text()}</option>`;
    } else if (i > 0 && $select.hasClass('select-menu--inactive')) {
      $select.attr('disabled', false);
      $select.removeClass('select-menu--inactive');
    }
    $select.html(
      `<option value="">${this.defaultCantonSelectText}</option>${options}`,
    );
  };
}

function MainBar(map) {
  this.map = map;

  this.update = function () {
    this.map.$mainBar
      .find('.polis-result__bar--main')
      .removeClass(css.defaultColor);
    if (this.map.result.results && this.map.result.results.mainResults) {
      let mainResults =
        new ResultSet(this.map.result.results.mainResults, map) || {};
      let cantonalResults =
        new ResultSet(this.map.result.cantonalResult, map) || {};
      this.render(
        mainResults,
        cantonalResults,
        this.calcLastUpdated(this.map.result),
      );
    } else if (
      this.map.result.results.results.length === 0 &&
      !this.map.result.results.mainResults
    ) {
      this.map.$mainBar
        .find('.polis-result__bar--main')
        .addClass(css.defaultColor);
      let $statusLine = this.map.$container.find(css.statusLine);
      $statusLine.text($statusLine.data('no-results'));
    }
  };

  this.calcLastUpdated = function (vote) {
    let lastUpdated = null;
    vote.results.results.forEach(
      function (result) {
        let ts = new Date(this.getUpdateDateTime(result.update));
        if (lastUpdated == null || ts > lastUpdated) {
          lastUpdated = ts;
        }
      }.bind(this),
    );
    return lastUpdated;
  };

  this.getUpdateDateTime = function (dateTime) {
    if (moment(dateTime).isValid()) {
      dateTime = moment(dateTime).locale('datetime');
    }
    return dateTime;
  };

  this.render = function (nationalResults, cantonalResults, lastMod) {
    this.renderMainBar(nationalResults);
    this.renderStateLine(nationalResults, lastMod);
    this.renderCantonalMajority(cantonalResults);
  };

  this.renderMainBar = function (nationalResults) {
    const { absolute, relative } = nationalResults;

    // absolute
    this.map.$mainBar
      .find(css.totalAbsoluteYesResult)
      .text(absolute.yes.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'"));
    this.map.$mainBar
      .find(css.totalAbsoluteNoResult)
      .text(absolute.no.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'"));

    // bars
    this.map.$mainBar.find(css.totalRelativeNoBar).width(relative.no + '%');
    this.map.$mainBar.find(css.totalRelativeYesBar).width(relative.yes + '%');

    // relative values
    this.map.$mainBar
      .find(css.totalRelativeYesResult)
      .html(parseFloat(relative.yes).toFixed(1));
    this.map.$mainBar
      .find(css.totalRelativeNoResult)
      .html(parseFloat(relative.no).toFixed(1));

    // stimmbeteiligung text
    if (relative.participation) {
      const $participation = this.map.$container.find(css.participation);
      $participation.text(relative.participation);
      $participation
        .closest('.' + css.hiddenClass)
        .removeClass(css.hiddenClass);
    }
  };

  this.renderStateLine = function (nationalResults, lastMod) {
    let $statusLine = this.map.$container.find(css.statusLine);
    let from = $statusLine.data('from');
    const { state, num_cantons } = nationalResults;

    if (num_cantons < 26) {
      const date = moment(lastMod).format('DD.MM.YYYY');
      const time = moment(lastMod).format('HH:mm');
      const at = $statusLine.data('at');
      const oClock = $statusLine.data('o-clock');
      const of26 = $statusLine.data('of-26');

      $statusLine.html(`
        <span>${state}</span> ${from} <time>${date}</time> ${at} <time>${time}</time> ${oClock} (${num_cantons} ${of26})
      `);
    } else {
      const date = moment(new Date(this.map.caseDate)).format('DD.MM.YYYY');

      $statusLine.html(`<span>${state}</span> ${from} <time>${date}</time>`);
    }
  };

  this.renderCantonalMajority = function (cantonalResults) {
    if (this.map.hasCantonalMajority) {
      let total = cantonalResults.relative.yes + cantonalResults.relative.no;
      this.map.$container
        .find(css.cantonalMajorityYesResult)
        .text(
          cantonalResults.absolute.yes
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, "'"),
        );
      this.map.$container
        .find(css.cantonalMajorityNoResult)
        .text(
          cantonalResults.absolute.no
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, "'"),
        );
      this.map.$container
        .find(css.cantonalMajorityYesBar)
        .width(cantonalResults.relative.yes + '%');
      this.map.$container
        .find(css.cantonalMajorityNoBar)
        .width(cantonalResults.relative.no + '%');
      this.map.$container
        .find(css.cantonalMajorityDefaultResult)
        .width(100 - total + '%');
    }
  };
}

function Canton(parentId, id, $container) {
  this.id = id;
  this.$element = $('#' + parentId + ' #' + id + '-' + parentId);
  this.$container = $container;
  this.yes = undefined;
  this.no = undefined;
  this.absoluteVotes = undefined;
  this.name = undefined;
  this.results = undefined;
  this.decorator = new ColorDecorator();
  this.districtResults = {};

  this.hasResults = function () {
    return this.results !== undefined;
  };

  this.setResultForDistrict = function (key, result) {
    this.districtResults[key] = result;
  };

  this.getNumberOfDistricts = function () {
    return Object.keys(this.districtResults).length;
  };

  this.renderResults = function () {
    // hidden on page load only
    this.$container.find(css.districtsWrapper).show();
    this.$container.find(css.cantonTitle).text(this.name);

    this.renderMainResults();
    this.renderDistricts();
  };

  this.renderMainResults = function () {
    const $results = this.$container.find(css.cantonalMainResult);
    const { absolute, relative } = this.results;

    $results
      .find(css.totalAbsoluteYesResult)
      .text(absolute.yes.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'"));
    $results
      .find(css.totalAbsoluteNoResult)
      .text(absolute.no.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'"));

    // bars
    $results.find(css.totalRelativeYesBar).width(relative.yes + '%');
    $results.find(css.totalRelativeNoBar).width(relative.no + '%');

    // relative values
    $results
      .find(css.totalRelativeYesResult)
      .html(parseFloat(relative.yes).toFixed(1));
    $results
      .find(css.totalRelativeNoResult)
      .html(parseFloat(relative.no).toFixed(1));
  };

  this.getDistrictContent = function (name = '', yes = 0, no = 0) {
    const yesClass = yes > no ? 'polis-district--yes' : '';
    const noClass = no >= yes ? 'polis-district--no' : '';
    const yesValue =
      yes.toFixed(1) === no.toFixed(1) ? yes.toFixed(0) : yes.toFixed(1);
    const noValue =
      no.toFixed(1) === yes.toFixed(1) ? no.toFixed(0) : no.toFixed(1);

    return `
      <li class="polis-district">
        <span class="polis-district__name">${name}</span>
        <span title="${YES} %" class="polis-district__votes ${yesClass}">${yesValue}% ${YES.toUpperCase()}</span>
        <span title="${NO} %" class="polis-district__votes ${noClass}">${noValue}% ${NO.toUpperCase()}</span>
      </li>`;
  };

  this.renderDistricts = function () {
    let $districtContainer = this.$container.find(css.districtContainer);
    let html = '';
    for (let district in this.districtResults) {
      html += this.getDistrictContent(
        district,
        this.districtResults[district].relative.yes,
        this.districtResults[district].relative.no,
      );
    }
    $districtContainer.html('').html(html);
  };

  this.setYes = function (yes) {
    this.yes = yes;
    this.setColor();
  };

  this.setColor = function () {
    if (this.yes === undefined || this.yes === '') {
      this.$element.attr('class', 'polis-initial chmap__location');
    } else if (this.yes === 50) {
      this.$element.attr(
        'class',
        this.decorator.getColorForAbsolute(this.absoluteVotes) +
          ' chmap__location',
      );
    } else {
      this.$element.attr(
        'class',
        this.decorator.getColorForPercent(this.yes) + ' chmap__location',
      );
    }
  };

  this.reset = function () {
    this.yes = undefined;
    this.no = undefined;
    this.results = undefined;
    this.absoluteVotes = undefined;
    this.setColor();
  };
}

function ResultSet(result, map) {
  this.last_update = result.update;
  this.relative = {
    yes: result.relative.yes,
    no: result.relative.no,
    participation: result.relative.participation,
  };
  this.absolute = {
    yes: result.absolute.yes,
    no: result.absolute.no,
  };

  this.map = map;
  this.num_cantons = Object.keys(map.cantonIdMap).length;
  let $wrapper = $(css.polisWrapper);
  this.state =
    this.num_cantons === 26
      ? $wrapper.data('final-result')
      : $wrapper.data('intermediate-result');
}

function ColorDecorator() {
  this.getColorForAbsolute = function (absolute) {
    return absolute.yes > absolute.no ? 'res-55' : 'res-50';
  };
  this.getColorForPercent = function (percent) {
    return 'res-' + this.getBracket(percent);
  };
  this.getBracket = function (x) {
    if (x <= 35) {
      return 0;
    }
    if (x <= 40) {
      return 40;
    }
    if (x <= 45) {
      return 45;
    }
    if (x <= 50) {
      return 50;
    }
    if (x <= 55) {
      return 55;
    }
    if (x <= 60) {
      return 60;
    }
    if (x <= 65) {
      return 65;
    }
    return 100;
  };
}
